import {
  styles,
  variants,
  NavigationListItemTheme
} from '../../../UNSAFE_NavigationList/themes/NavigationListItemStyles.css';
import { baseTheme } from '../../../UNSAFE_NavigationList/themes/redwood/NavigationListItemBaseTheme.css';
import { multiVariantStyles } from '../../../UNSAFE_NavigationList/themes/redwood/NavigationListItemVariants.css';

const NavigationListItemRedwoodTheme: NavigationListItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { NavigationListItemRedwoodTheme };
